import React from 'react';
import MethodBtn from '../common/MethodBtn';
import { injectIntl } from 'react-intl';
import { slaves } from '../../services/ApiService';
import { getSlaveId } from '../Statistics/statisticsHelpers';
import { FMessage, iFMessage } from '../../hoc/IntlComponents';

const DeleteMebmerBtn = (props) => {
  const slaveId = getSlaveId();
  const handleDeleteSlave = () => {
    const { showAlert, intl } = props;
    showAlert({
      alertType: 'success',
      message: iFMessage({ intl, id: 'slaves.delete-member.success' }),
      closeInSeconds: 3,
    });
  };
  return (
    <MethodBtn
      color="red"
      btnLabelId="slaves.btn.delete-member"
      api={slaves}
      method="deleteSlave"
      params={slaveId}
      withModal
      redirectPath="/tools/master"
      modalProps={{
        yesBtnId: 'main.delete',
        noBtnId: 'main.cancel',
        body: (
          <>
            <h3>
              <FMessage id="slaves.delete-member.question" />
            </h3>
            <p>
              <FMessage id="slaves.delete-member.question-text" />
            </p>
          </>
        ),
      }}
      customAction={handleDeleteSlave}
      timeOut={3000}
    />
  );
};

export default injectIntl(DeleteMebmerBtn);
